import { useState, useMemo } from "react"
import { ReactComponent as RejectImg } from "../assets/reject.svg"

const MIN_ANSWERS = 2;
const MAX_ANSWERS = 8;

export default function PollForm(props) {
    const [multiAnswers, setMultiAnswers] = useState(false);
    const [question, setQuestion] = useState("");
    const [answers, setAnswers] = useState(["", ""]);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const isValid = useMemo(() => {
        return question.trim() !== "" && answers.map((a) => a.trim()).filter((a) => a !== "").length >= MIN_ANSWERS;
    }, [question, answers]);

    const addAnswer = (event) => {
        event?.preventDefault();
        if (answers.length >= MAX_ANSWERS) return;
        setAnswers([...answers, ""]);
    }

    const updateAnswer = (index, text) => {
        setAnswers(Object.assign([], answers, { [index]: text }));
    }

    const removeAnswer = (event, index) => {
        event.preventDefault();
        if (answers.length <= MIN_ANSWERS) return;
        setAnswers(answers.filter((_, i) => i !== index));
    }

    const renderAnswer = (answer, index) => {
        return <div key={index} className="flex border border-gray-400 focus-within:border-primary rounded px-2 space-x-3">
            <input
                type="text"
                className="flex-1 bg-transparent outline-none py-2 placeholder-gray-500"
                placeholder={`${index + 1}. Answer`}
                value={answer}
                maxLength={120}
                disabled={isSubmitting}
                onChange={(e) => updateAnswer(index, e.target.value)} />

            <button
                type="button" onClick={(e) => removeAnswer(e, index)}
                className="transition-colors text-gray-500 disabled:text-gray-300 hover:text-primary"
                tabIndex={-1}
                disabled={isSubmitting || answers.length <= MIN_ANSWERS}>
                    <RejectImg />
                </button>
        </div>;
    }

    const onSubmit = (event) => {
        event.preventDefault();
        doSubmit(props.onSubmit);
    }

    const onSave = (event) => {
        event.preventDefault();

        doSubmit(props.onSave);
    }

    const doSubmit = (fn) => {
        setIsSubmitting(true);

        fn(
            multiAnswers ? "multi" : "single",
            question.trim(),
            answers.map((a) => a.trim()).filter((a) => a !== "")
        ).catch((error) => {
            console.error(error);
            setIsSubmitting(false);
        });
    }

    const renderActions = () => {
        if (props.onCancel != null && !isValid) {
            return <button onClick={props.onCancel} className="btn-secondary flex-1" disabled={isSubmitting}>Cancel</button>;
        }

        return <button onClick={onSave} className="btn-secondary flex-1" disabled={!isValid || isSubmitting}>Save for later</button>;
    }

    return (
        <form onSubmit={onSubmit} readOnly={true} className="space-y-3">
            <input
                type="text"
                className="w-full bg-transparent border-b-2 border-gray-400 placeholder-gray-500 p-2 outline-none transition-colors focus:border-primary"
                placeholder="Write a question"
                value={question}
                disabled={isSubmitting}
                maxLength={120}
                onChange={(e) => setQuestion(e.target.value)} />

            {answers.map(renderAnswer)}

            <button disabled={answers.length >= MAX_ANSWERS} onClick={addAnswer}>+ Add answer</button>

            <label className="flex items-center space-x-2 cursor-pointer mb-1">
                <input
                    type="checkbox"
                    checked={multiAnswers}
                    disabled={isSubmitting}
                    onChange={(e) => setMultiAnswers(e.target.checked)}
                    className="form-check" />
                <span>Allow multiple answers</span>
            </label>

            <div className="flex space-x-3">
                {renderActions()}
                <button type="submit" className="btn-primary flex-1" disabled={!isValid || isSubmitting}>Ask audience now</button>
            </div>
        </form>
    );
}
